import React from "react";
import { Chip as MuiChip, Theme } from "@mui/material";
import { SxProps } from "@mui/material/styles";

type ChipProps = {
  children: React.ReactNode;
  variant?: "RED" | "GREEN" | "YELLOW" | "ORANGE" | "GRAY";
  theme: Theme;
  sx?: SxProps<Theme>;
  onClick?: () => void;
};

export const Chip: React.FC<ChipProps> = ({
  children,
  variant = "GREEN",
  theme,
  sx,
  onClick,
}) => {
  const getChipStyles = () => {
    const baseStyles: SxProps<Theme> = {
      height: "auto",
      borderRadius: "100px",
      fontSize: "13px",
      lineHeight: "18px",
      fontWeight: 400,
      "& .MuiChip-label": {
        px: 1,
        py: 0.25,
      },
    };

    switch (variant) {
      case "RED":
        return {
          ...baseStyles,
          backgroundColor: theme.palette.error.light, // errorLight
          borderColor: theme.palette.error.main, // errorMain
          color: theme.palette.textMain.dark2, // textDark2
          border: `1px solid ${theme.palette.error.main}`,
        };
      case "ORANGE":
        return {
          ...baseStyles,
          backgroundColor: theme.palette.warning.main, // warningMain
          borderColor: theme.palette.warning.dark, // warningDark
          color: theme.palette.textMain.dark2, // textDark2
          border: `1px solid ${theme.palette.warning.dark}`,
        };
      case "GREEN":
        return {
          ...baseStyles,
          backgroundColor: theme.palette.brand.light, // brandSecondaryLight
          borderColor: theme.palette.brand.main, // brandSecondaryMain
          color: theme.palette.textMain.dark2, // textDark2
          border: `1px solid ${theme.palette.brand.main}`,
        };
      case "YELLOW":
        return {
          ...baseStyles,
          backgroundColor: theme.palette.warning.light, // warningLight
          borderColor: theme.palette.warning.dark, // warningDark
          color: theme.palette.textMain.dark2, // textDark2
          border: `1px solid ${theme.palette.warning.dark}`,
        };
      case "GRAY":
        return {
          ...baseStyles,
          backgroundColor: "#e5e6e6", // textLight2 (gray)
          borderColor: theme.palette.textMain.main2, // textLight2 (gray)
          color: theme.palette.textMain.dark2, // textLight (white)
          border: `1px solid ${theme.palette.textMain.light2}`,
        };
      default:
        return {
          ...baseStyles,
          backgroundColor: theme.palette.brand.light, // brandSecondaryLight
          borderColor: theme.palette.brand.main, // brandSecondaryMain
          color: theme.palette.textMain.dark2, // textDark2
          border: `1px solid ${theme.palette.brand.main}`,
        };
    }
  };

  const chipStyles = getChipStyles();

  return (
    <MuiChip
      label={children}
      size="small"
      onClick={onClick}
      sx={{
        ...chipStyles,
        ...sx,
      }}
    />
  );
};

export default Chip;
